export default __webpack_public_path__ + "static/media/093-turn-left.48baf4e7.png";